





















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
import {
  UploadFile,
  GetDictionaryData,
  PostAddKepu,
  GetKepuDetail,
  PatchEditKepu,
} from "@/request/common";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
    DsEditor,
  },
})
export default class Name extends Vue {
  private types: any = [];
  private types2: any = [];
  private type: any = "";
  private data: any = {
    name: "", // 标题
    author: "", // 作者
    cover: "", //封面
    content_type: [], //内容领域
    content_level: {}, //课程类别
    introduce: "", //简介
    content: "", //正文
    video: [], // 视频
    file: [], // 视频
    check_status: "未发布",
  };
  private get user() {
    return this.$store.state.user;
  }
  private previewFile(url: any) {
    window.open(url);
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private editorChange(e: any) {
    this.data.content = e;
  }
  private preview() {
    window.open(this.data["封面"]);
  }
  private save() {
    if (!this.data.name) {
      this.$message.warning("请输入标题！");
      return;
    }
    if (this.data.content_type.length == 0) {
      this.$message.warning("请选择内容领域！");
      return;
    }
    if (!this.data.content_level.id) {
      this.$message.warning("请选择课程类别！");
      return;
    }
    if (
      this.data.file_type == "视频" &&
      (!this.data.file || this.data.file.length == 0)
    ) {
      this.$message.warning("请上传视频！");
      return;
    }
    if (
      this.data.file_type == "文件" &&
      (!this.data.file || this.data.file.length == 0)
    ) {
      this.$message.warning("请上传文件！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.data.id) {
      PatchEditKepu(this, this.data.id, this.data).then((res: any) => {
        this.$message.success("保存成功！");
        this.$router.back();
      });
    } else {
      PostAddKepu(this, this.data, loading).then((res: any) => {
        this.$message.success("保存成功！");
        this.$router.back();
      });
    }
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.data.cover = res.data.file_url;
      this.$forceUpdate();
    });
  }
  private uploadVideo(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.data.file = [res.data];
      this.$forceUpdate();
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetKepuDetail(this, this.data.id, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }
  private getType() {
    const params: any = {
      params: {
        values: "课程类别",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types = res.data;
    });
  }
  private getType2() {
    const params: any = {
      params: {
        values: "内容领域",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types2 = res.data;
    });
  }
  private mounted() {
    this.getType();
    this.getType2();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    } else {
      this.data.file_type = this.type;
    }
  }
}
